import React from 'react';
import Sidebar2 from '../../images/sidebar2.png';

const Shop = () => (
    <div className="sidewidget widgetnopadd">
        <div className="sidebarimg">
            <img src={Sidebar2} alt="sidebar 2" />
            <a
                href="https://clients.mindbodyonline.com/Pages/OnlineStore.aspx?studioid=5741620&partnerID=0&catid="
                target="_blank"
                rel="noopener noreferrer"
                className="wrtsbtn yellowbtn inlinebtn"
            >
                CHECK OUT OUR ROCK SHOP
            </a>
        </div>
    </div>
);

export default Shop;
